import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { FaqSection } from "@/components/sections/HomeSections";
import SEO, { faqSchema } from "@/components/SEO";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then(r => setFaqs(r.data)).catch(()=>{}); }, []);
  return (
    <div data-testid="faq-page" className="pt-32">
      <SEO title="Frequently Asked Questions" path="/faq"
           description="Honest answers to the questions couples ask us most — about booking, our process, what's included, delivery times, and more."
           jsonLd={faqs.length ? faqSchema(faqs) : null} />
      <section className="section-pad pb-0 max-w-[1400px] mx-auto text-center">
        <div className="eyebrow">FAQ</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light mt-4 tracking-tight">Questions We're <em className="text-[#D4AF37] not-italic">Often Asked</em></h1>
        <p className="text-white/55 mt-4 max-w-2xl mx-auto">Honest answers about how we work, what's included, and how to plan your wedding with us.</p>
      </section>
      <FaqSection />
    </div>
  );
}
